<template>
    <div class="app-container">
        <!-- <div class="detailsTitle">
            <h4>排队设置</h4>
        </div> -->
        <div style="padding: 20px 0 0 0;">
            <el-form :model="searchFrom" :rules="rules" ref="searchFrom" inline label-width="120px">
                <el-form-item label="呼叫过号时间:" prop="overDate" class="jiage">
                    <el-input maxlength="10" placeholder="请输入" :disabled="flag"   @input="searchFrom.overDate=searchFrom.overDate.replace(/^(0+)|[^\d]+/g,'')" size="mini"
                        v-model.number="searchFrom.overDate" ></el-input>
                    <span class="danwei">分钟</span>
                </el-form-item>
                <el-form-item label="过号次数上限:" prop="overNumber" class="jiage">
                    <el-input placeholder="请输入" maxlength="10" :disabled="flag" @input="searchFrom.overNumber=searchFrom.overNumber.replace(/^(0+)|[^\d]+/g,'')" size="mini"
                        v-model.number="searchFrom.overNumber"></el-input>
                    <span class="danwei">次</span>
                </el-form-item>
                <div class="panel">
                    <!-- <el-button type="primary" @click="handleSubmit">保 存</el-button> -->
                    <el-button type="primary" @click="successFn(1)" btnCode="01K0080100" v-if="btnFlg[0] && !flag">保
                        存</el-button>
                    <el-button type="primary" @click="successFn(2)" btnCode="01K0080200" v-if="btnFlg[1] && flag">编
                        辑</el-button>
                    <el-button type="primary" @click="searchFn" :disabled="flag">取 消</el-button>

                </div>
            </el-form>
        </div>
    </div>
</template>
<script>
import { editLineUp, getLineUp } from '@/api/lj'
import { getBtn } from '@/utils/getButton'
import DonMessage from '@/utils/message'

export default {
  data () {
    return {
      searchFrom: {},
      flag: false,
      rules: {
        overDate: [
          { required: true, message: '请输入呼叫过号时间', trigger: ['blur', 'change'] },
          {
            validator: function (rule, value, callback) {
              if (value) {
                callback()
              } else {
                let tip = ''

                if (value * 1 === 0) {
                  tip = '呼叫过号时间应大于0'
                }

                if (tip) {
                  callback(new Error(tip))
                } else {
                  callback()
                }
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        overNumber: [
          { required: true, message: '请输入过号次数上限', trigger: ['blur', 'change'] },
          {
            validator: function (rule, value, callback) {
              if (value) {
                callback()
              } else {
                let tip = ''

                if (value * 1 === 0) {
                  tip = '过号次数上限应大于0'
                }

                if (tip) {
                  callback(new Error(tip))
                } else {
                  callback()
                }
              }
            },
            trigger: ['blur', 'change']
          }
        ]
      },
      btnFlg: [],
      btnIdArr: ['01K0080100', '01K0080200', '01K0080300']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/settings')
    this.getList()
  },
  mounted () { },
  methods: {

    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    handleChange () {
      // 通过正则表达式判断输入是否符合要求
      if (/^(0|[1-9][0-9]*)$/.test(this.searchFrom.poundDifference)) {
        // 转换为整数并限制范围为1-100
        let num = parseInt(this.searchFrom.poundDifference)
        if (num < 1) {
          num = 1
        } else if (num > 100) {
          num = 100
        }
        this.searchFrom.poundDifference = num.toString()
      } else {
        // 不符合要求则清空输入框
        this.searchFrom.poundDifference = ''
      }
    },
    getList () {
      getLineUp(this.searchFrom)
        .then((res) => {
          this.searchFrom = {}
          if (res == null) {
            this.flag = false
            this.$refs.searchFrom.clearValidate()
          } else {
            this.flag = true

            let obj = { ...res }
            this.$set(this.searchFrom, 'overDate', obj.itemNo)
            this.$set(this.searchFrom, 'overNumber', obj.showName)
            this.$set(this.searchFrom, 'id', obj.id)
          }
        })
        .catch((error) => {
          this.$message({
            message: error.message,
            type: 'error',
            onClose () { }
          })
        })
    },
    successFn (val) {
      this.$refs.searchFrom.validate((valid) => {
        if (valid) {
          // 保存
          if (val == 1) {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            editLineUp(this.searchFrom).then(res => {
              DonMessage.success('保存成功')
              loading.close()
              this.searchFrom = {}
              this.getList()
            }).catch(err => {
              loading.close()

              DonMessage.error(err.message)
            })
          } else {
            // 修改
            this.flag = false
          }
        }
        // this.getList()
      })
    }
  }
}
</script>
<style scoped lang="less">
.el-form {
    width: 400px;
    margin-left: 10px;

    .el-form-item {
        margin-bottom: 20px;

        .el-input {
            width: 200px;
        }
    }

    .panel {
        margin-left: 10px
    }
}

/deep/.el-input.is-disabled .el-input__inner {

    color: #000000;
}

/deep/.jiage .el-form-item__content {
    position: relative;

    .danwei {
        position: absolute;
        // right: -20px;
        padding: 1px 9px;
    }
}
</style>
